import { LoggerService } from './logger.service';
import type { ChildLoggerOptions, Logger, LoggerConfiguration } from './logging.types';

let root: LoggerService | null = null;

/**
 * The module-level root logger: works before the container exists, in
 * containerless runtimes (React Native, jest), and is the same instance the
 * web composition root configures. Children are cached per name (options
 * apply on first creation), which also makes them stable spy targets.
 */
export function getLogger(): LoggerService;
export function getLogger(name: string, options?: ChildLoggerOptions): Logger;
export function getLogger(name?: string, options?: ChildLoggerOptions): Logger {
    root = root ?? new LoggerService();

    return name === undefined ? root : root.child(name, options);
}

/** Apply environment configuration to the root logger. Composition-root use. */
export function configureLogger(configuration: LoggerConfiguration): void {
    getLogger().configure(configuration);
}

/** Discard the root so the next `getLogger()` starts fresh. Test use only. */
export function resetLoggerForTesting(): void {
    root = null;
}
